import { createRouter, createWebHistory } from 'vue-router';
import AiCorrection from '@/views/Dashboard.vue';
import defaultLayout from '@/layouts/defaultLayout.vue';
import UserManager from '@/views/user/UserManager.vue';
import TopicManager from '@/views/speaking/TopicManager.vue';
import TopicDetector from '@/views/speaking/TopicDetector.vue';
import QuestionManager from '@/views/speaking/QuestionManager.vue';
import PlanManager from '@/views/membership/PlanManager.vue';
import CategoryManager from '@/views/membership/CategoryManager.vue';
import FeatureManager from '@/views/membership/FeatureManager.vue';
import RedeemCodeManager from '@/views/membership/RedeemCodeManager.vue';
import PaperManagement from '@/views/mock/PaperManagement.vue';
import MockEditorWorkspace from '@/views/mock/MockEditorWorkspace.vue';
import CategoryManagement from '@/views/mock/CategoryManagement.vue';
import BookManagement from '@/views/mock/BookManagement.vue';
import DictationBookManagement from '@/views/dictation/BookManagement.vue';
import DictationCategoryManagement from '@/views/dictation/CategoryManagement.vue';
import DictationContentManagement from '@/views/dictation/ContentManagement.vue';
import DialogueBookManagement from '@/views/dictation/dialogue/BookManagement.vue';
import SystemLogs from '@/views/admin/SystemLogs.vue';
import ScheduledTasks from '@/views/admin/ScheduledTasks.vue';
import TenantManager from '@/views/admin/TenantManager.vue';
import TenantSettlementManager from '@/views/admin/TenantSettlementManager.vue';
import PlatformTutorSettlementManager from '@/views/admin/PlatformTutorSettlementManager.vue';
import TutorProfileReviews from '@/views/admin/TutorProfileReviews.vue';
import TutorRefundRequests from '@/views/admin/TutorRefundRequests.vue';
import MessageList from '@/views/message/MessageList.vue';
import MessageCreate from '@/views/message/MessageCreate.vue';
import MessageDetail from '@/views/message/MessageDetail.vue';
import MessageEdit from '@/views/message/MessageEdit.vue';
import AnnouncementList from '@/views/announcement/AnnouncementList.vue';
import PromoManager from '@/views/marketing/PromoManager.vue';
import AnnouncementCreate from '@/views/announcement/AnnouncementCreate.vue';
import AnnouncementDetail from '@/views/announcement/AnnouncementDetail.vue';
import AnnouncementEdit from '@/views/announcement/AnnouncementEdit.vue';
import TopicGroupList from '@/views/speaking/TopicGroupList.vue';
import TopicGroupEdit from '@/views/speaking/TopicGroupEdit.vue';
import PolicyManager from '@/views/referral/PolicyManager.vue';
import CommissionRecords from '@/views/referral/CommissionRecords.vue';
import WithdrawalManagement from '@/views/referral/WithdrawalManagement.vue';
import Login from '@/views/auth/Login.vue';
import { authGuard } from './guards';

const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/mock/papers/:paperId/editor',
            name: 'mock-paper-editor',
            component: MockEditorWorkspace,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/',
            name: '',
            component: defaultLayout,
            children: [
                {
                    path: '',
                    name: 'home',
                    component: AiCorrection,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'user-manager',
                    name: 'user-manager',
                    component: UserManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'topic-manager',
                    name: 'topic-manager',
                    component: TopicManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'topic-detector',
                    name: 'topic-detector',
                    component: TopicDetector,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'topic-manager/question-manager/:oralTopicId',
                    name: 'question-manager',
                    component: QuestionManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'plan-manager',
                    name: 'plan-manager',
                    component: PlanManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'category-manager',
                    name: 'category-manager',
                    component: CategoryManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'feature-manager',
                    name: 'feature-manager',
                    component: FeatureManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'redeem-code-manager',
                    name: 'redeem-code-manager',
                    component: RedeemCodeManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'mock/paper-management',
                    name: 'mock-paper-management',
                    component: PaperManagement,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'mock/category-management',
                    name: 'mock-category-management',
                    component: CategoryManagement,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'mock/book-management',
                    name: 'mock-book-management',
                    component: BookManagement,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/books',
                    name: 'dictation-books',
                    component: DictationBookManagement,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/books/:id',
                    name: 'dictation-book-detail',
                    component: () => import('@/views/dictation/BookDetail.vue'),
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/books/:bookId/chapters/:chapterId',
                    name: 'dictation-chapter-detail',
                    component: () => import('@/views/dictation/ChapterDetail.vue'),
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/dialogue/books',
                    name: 'dictation-dialogue-books',
                    component: DialogueBookManagement,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/dialogue/books/:id',
                    name: 'dictation-dialogue-book-detail',
                    component: () => import('@/views/dictation/dialogue/BookDetail.vue'),
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/dialogue/books/:bookId/chapters/:chapterId',
                    name: 'dictation-dialogue-chapter-detail',
                    component: () => import('@/views/dictation/dialogue/ChapterDetail.vue'),
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/categories',
                    name: 'dictation-categories',
                    component: DictationCategoryManagement,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'dictation/contents',
                    name: 'dictation-contents',
                    component: DictationContentManagement,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'tenant-manager',
                    name: 'tenant-manager',
                    component: TenantManager,
                    meta: {
                        authRequired: true,
                        superAdminRequired: true
                    }
                },
                {
                    path: 'tenant-settlements',
                    name: 'tenant-settlements',
                    component: TenantSettlementManager,
                    meta: {
                        authRequired: true,
                        superAdminRequired: true
                    }
                },
                {
                    path: 'tenant-commissions',
                    redirect: '/tenant-settlements'
                },
                {
                    path: 'platform-tutor-settlements',
                    name: 'platform-tutor-settlements',
                    component: PlatformTutorSettlementManager,
                    meta: {
                        authRequired: true,
                        superAdminRequired: true
                    }
                },
                {
                    path: 'tutor-profile-reviews',
                    name: 'tutor-profile-reviews',
                    component: TutorProfileReviews,
                    meta: {
                        authRequired: true,
                        superAdminRequired: true
                    }
                },
                {
                    path: 'tutor-refunds',
                    name: 'tutor-refunds',
                    component: TutorRefundRequests,
                    meta: {
                        authRequired: true,
                        superAdminRequired: true
                    }
                },
                {
                    path: 'system-logs',
                    name: 'system-logs',
                    component: SystemLogs,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'scheduled-tasks',
                    name: 'scheduled-tasks',
                    component: ScheduledTasks,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'message',
                    name: 'message-list',
                    component: MessageList,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'message/create',
                    name: 'message-create',
                    component: MessageCreate,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'message/:id',
                    name: 'message-detail',
                    component: MessageDetail,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'message/:id/edit',
                    name: 'message-edit',
                    component: MessageEdit,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'promo',
                    name: 'promo-manager',
                    component: PromoManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'app/version',
                    name: 'app-version',
                    component: () => import('@/views/app/VersionControl.vue'),
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'app/ota',
                    name: 'app-ota',
                    component: () => import('@/views/app/OtaRelease.vue'),
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'announcement',
                    name: 'announcement-list',
                    component: AnnouncementList,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'announcement/create',
                    name: 'announcement-create',
                    component: AnnouncementCreate,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'announcement/:id',
                    name: 'announcement-detail',
                    component: AnnouncementDetail,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'announcement/:id/edit',
                    name: 'announcement-edit',
                    component: AnnouncementEdit,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'topic-group',
                    name: 'topic-group-list',
                    component: TopicGroupList,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'topic-group/create',
                    name: 'topic-group-create',
                    component: TopicGroupEdit,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'topic-group/:id/edit',
                    name: 'topic-group-edit',
                    component: TopicGroupEdit,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'referral/policies',
                    name: 'referral-policies',
                    component: PolicyManager,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'referral/commissions',
                    name: 'referral-commissions',
                    component: CommissionRecords,
                    meta: {
                        authRequired: true
                    }
                },
                {
                    path: 'referral/withdrawals',
                    name: 'referral-withdrawals',
                    component: WithdrawalManagement,
                    meta: {
                        authRequired: true
                    }
                }
            ]
        }
    ]
});

router.beforeEach(authGuard);

export default router;
